import {
  FETCHED_HISTORY,
  START_FETCHING_HISTORY
} from '../actionTypes';

import { HistoryAudioType } from '../../types/AppTypes';

interface InitialState {
  historyAudio:HistoryAudioType[];
  loading: boolean;
  error: any;
  message: any;
  tablePageSize: number;
  currentPage: number;
}

const initialState: InitialState = {
  historyAudio: [],
  loading: false,
  error: null,
  message: null,
  tablePageSize: 10,
  currentPage: 1,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action: any) {
  switch (action.type) {
    case START_FETCHING_HISTORY:
      return {
        ...state,
        historyAudio: [],
        error: null,
        message: null,
        loading: true,
      };
    case FETCHED_HISTORY: {
      const { historyAudio, error, message } = action.payload;
      return {
        ...state,
        historyAudio,
        error,
        message,
        loading: false,
      };
    }
    default:
      return state;
  }
}
